import VuexTypes from '@/store/types/index';

const StructuresTypes = VuexTypes.structures;

export default {
  [StructuresTypes.STRUCTURES_LIST]: (state, { data, status }) => {
    state.structuresList = { data, status };
  },
  [StructuresTypes.STRUCTURE_UPDATE_DATA]: (state, { data, status }) => {
    state.structureUpdateData = { data, status };
  },
  [StructuresTypes.STRUCTURE_CREATE_DATA]: (state, { data, status }) => {
    state.structureCreateData = { data, status };
  },
  [StructuresTypes.STRUCTURE_CREATE]: (state, { data, status }) => {
    state.structureCreate = { data, status };
  },
  [StructuresTypes.STRUCTURE_UPDATE]: (state, { data, status }) => {
    state.structureUpdate = { data, status };
  },
  [StructuresTypes.ADD_USER]: (state, { data, status }) => {
    state.addUser = { data, status };
  },
  [StructuresTypes.DELETE_USER]: (state, { data, status }) => {
    state.deleteUser = { data, status };
  },
};
